// 督促メール
export const ReminderMailBatchType: string = '23'
// 学校用貸出統計
export const SchoolStaticsLendBatchType: string = 'C1'
// 学校用ベストリーダ
export const SchoolStaticsBestReaderBatchType: string = 'C2'
// 学校用貸出資料一覧
export const SchoolLendCollectionListBatchType: string = 'C3'
// 学校用利用者一覧
export const SchoolUserList: string = 'C4'
// TRC目次情報登録
export const TrcContentDataRegister: string = '38'
// TRC目次情報更新
export const TrcContentDataUpdate: string = '39'
// TRC典拠情報登録
export const TrcAuthorityRegisterBatchType: string = '40'
// TRC典拠情報更新
export const TrcAuthorityUpdateBatchType: string = '41'
